/**
 * @ngdoc component
 * @name  common.product.product-color.component:itxProductViewMenu
 * @requires   $rootScope
 * @requires   $scope
 * @requires   $window
 * @requires   ItxShopCartFct
 * @requires   ItxScreenSizeSvc 
 * @requires   ItxHeaderFct
 * @requires   ItxShareDataFct
 * @requires   imDataService
 * @description
 * Product view menu component.
 * Will show add to cart and wishlist button
*/
(function () {

    'use strict';

    var itxProductViewMenuCmp = {
        bindings: {
            product: '<',
            color: '<',
            inBundleDialog: '<',
            noShowMiniCart:'<',
            onProductClick:'&',
            productUrl: '<',
        },
        controller: itxProductViewMenuCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'ItxProductViewMenu.html'
    };

    angular.module('itxApp.common')
        .component('itxProductViewMenu', itxProductViewMenuCmp);

    itxProductViewMenuCmpCtrl.$inject = [ 
        'ItxShopCartFct',
        'ItxScreenSizeSvc'
    ];

    function itxProductViewMenuCmpCtrl( 
        ItxShopCartFct,
        ItxScreenSizeSvc
    ) {

        var _this = this;

        _this.isPageAllowed = (inditex.iPage === 'ItxCategoryPage' || inditex.iPage === 'ItxProductPage' || inditex.iPage === 'ItxSearchPage');

        _this.$onInit = function () {
            _this.isOpenForSale = inditex.iStoreJSON != undefined && inditex.iStoreJSON.isOpenForSale;
        };

        _this.addToCart = function () {
            var openPopup = false;
            
            if (ItxScreenSizeSvc.is('sm,md,lg') && _this.isPageAllowed) {
                if(!_this.noShowMiniCart && !_this.inBundleDialog){
                    openPopup = true;
                }
            }

            ItxShopCartFct.addCart( _this.product, openPopup)
            .then(function(){
                // TODO
                _this.product.state.selectedSize = null;
            });
        };
    }

})();
